import { defineMessages } from 'react-intl'

export const FEEDBACK_TYPE = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
} as const

export const FEEDBACK_WORD_CHIPS = defineMessages({
  AVAILABILITY: {
    defaultMessage: 'Availability',
    description: 'Selectable reason for negative feedback: Availability',
  },
  NOT_IN_PERSON: {
    defaultMessage: 'Not in-person',
    description: 'Selectable reason for negative feedback: Not in-person',
  },
  SPECIALTY: {
    defaultMessage: 'Specialty',
    description: 'Selectable reason for negative feedback: Specialty',
  },
  GENDER: {
    defaultMessage: 'Gender',
    description: 'Selectable reason for negative feedback: Gender',
  },
  GENDER_OR_RACE_ETHNICITY: {
    defaultMessage: 'Gender or race/ethnicity',
    description: 'Selectable reason for negative feedback: Gender or race/ethnicity',
  },
  OTHER_PREFERENCES: {
    defaultMessage: 'Other preferences',
    description: 'Selectable reason for negative feedback: Other preferences',
  },
})

export const FEEDBACK_WORD_CHIPS_WITH_RACE_ETHNICITY = [
  FEEDBACK_WORD_CHIPS.AVAILABILITY,
  FEEDBACK_WORD_CHIPS.NOT_IN_PERSON,
  FEEDBACK_WORD_CHIPS.SPECIALTY,
  FEEDBACK_WORD_CHIPS.GENDER_OR_RACE_ETHNICITY,
  FEEDBACK_WORD_CHIPS.OTHER_PREFERENCES,
]

export const FEEDBACK_WORD_CHIPS_WITHOUT_RACE_ETHNICITY = [
  FEEDBACK_WORD_CHIPS.AVAILABILITY,
  FEEDBACK_WORD_CHIPS.NOT_IN_PERSON,
  FEEDBACK_WORD_CHIPS.SPECIALTY,
  FEEDBACK_WORD_CHIPS.GENDER,
  FEEDBACK_WORD_CHIPS.OTHER_PREFERENCES,
]

export const FEEDBACK_TYPE_FIELD_NAME = 'feedbackType'
export const WORD_CHIPS_FIELD_NAME = 'wordChips'
export const TEXT_AREA_FIELD_NAME = 'feedbackText'

export const FEEDBACK_TRIGGER_LINK_TEXT = defineMessages({
  default: {
    defaultMessage: 'Is this provider a fit?',
    description: 'Button to open provider feedback survey',
  },
  isFavorited: {
    defaultMessage: 'Is this provider still a fit?',
    description: 'Button to open provider feedback survey when provider is favorited',
  },
})
